import { resolveIntlLocale } from '../../lib/locale'

export interface FormattedAppointmentParts {
  /** e.g. "Wednesday, 26 January" */
  date: string
  /** e.g. "12:30" */
  time: string
}

/**
 * Splits a booking timeslot for confirmation copy.
 * Figma (6014:14085): "See you on Wednesday, 26 January at 12:30."
 */
export function formatAppointmentDateParts(
  iso: string,
  language = 'en',
): FormattedAppointmentParts | null {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return null

  const locale = resolveIntlLocale(language)

  return {
    date: new Intl.DateTimeFormat(locale, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    }).format(date),
    time: new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(date),
  }
}
